import ComparisonItem from '@/types/comparison-item';
import { HOLDING_TYPES } from './portfolios';

/**
 * Checks if item has alt
 * @param {ComparisonItem} item the item to validate
 */
export const doesItemHasAlt = (item: ComparisonItem) => item.holdings.some(h => h.type === HOLDING_TYPES.ALT);

/**
 * Filters valid comparison items for historical scenarios
 * @param {ComparisonItem[]} items the items to filter
 */
export const filterHistoricalScenarioItems = (items: ComparisonItem[]) => items.filter(item => !doesItemHasAlt(item));
